<div class="link-block container-fluid">
  <div class="row">
    <div class="col-12 col-xl-10 mx-auto">
      <div class="row">
        <div class="col-12 d-lg-none mb-2">
          <h2>{{ caption }}</h2>
        </div>
        <div class="col-12 col-md-5 col-xl-7 d-flex align-items-center">
          <img
            [src]="media"
            *ngIf="media && mediaType === 'Image'"
            [alt]="caption"
            class="image-aspect-ratio"
          />
          <video
            class="video"
            *ngIf="media && mediaType === 'Video'"
            controls
            (click)="playVideo()"
            #videoPlayer
          >
            <source [src]="media" [type]="" />
            {{ "browserSupportVideo" | translate }}
          </video>
        </div>
        <div
          class="col-12 col-md-6 col-xl-4 offset-0 offset-md-1 d-flex align-items-center"
        >
          <div class="col-12 px-0">
            <div class="content">
              <h2 class="d-none d-lg-block">{{ caption }}</h2>
              <p>{{ body }}</p>
              <vw-link
                *ngIf="link"
                [text]="'readMore' | translate"
                [href]="link"
                icon="fa-long-arrow-right fal"
                [regularLink]="true"
                [anchorTagClass]="'text-link'"
              ></vw-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
